import { ReportConfig } from "../../pages/reportConfigs/typings";
import * as actionTypes from "./types";

export const setUser = (user) => {
  return {
    type: actionTypes.SET_USER,
    payload: {
      currentUser: user,
    },
  };
};

export const clearUser = (): {} => {
  return {
    type: actionTypes.CLEAR_USER,
  };
};

export const resetUser = (): {} => {
  return {
    type: actionTypes.RESET_USER,
  };
};

export const setCustomer = (customer) => {
  return {
    type: actionTypes.SET_CUSTOMER,
    payload: {
      currentCustomer: customer,
    },
  };
};

export const setCustomers = (customers) => {
  return {
    type: actionTypes.SET_CUSTOMERS,
    payload: {
      customers,
    },
  };
};

export const setAlert = (text, severity) => {
  return {
    type: actionTypes.SET_ALERT,
    payload: {
      open: true,
      text,
      severity,
    },
  };
};

export const clearAlert = () => {
  return {
    type: actionTypes.CLEAR_ALERT,
  };
};

export const setVehicleTemplate = (template) => {
  return {
    type: actionTypes.SET_VEHICLE_TEMPLATE,
    payload: { template },
  };
};

export const clearVehicleTemplate = () => {
  return {
    type: actionTypes.CLEAR_VEHICLE_TEMPLATE,
  };
};

export const setDevice1 = (device1) => {
  return {
    type: actionTypes.SET_DEVICE1,
    payload: {
      device1,
    },
  };
};

export const setDevice2 = (device2) => {
  return {
    type: actionTypes.SET_DEVICE2,
    payload: {
      device2,
    },
  };
};

export const setVehicle = (vehicle) => {
  return {
    type: actionTypes.SET_VEHICLE,
    payload: {
      vehicle,
    },
  };
};

export const setDevice = (device) => {
  return {
    type: actionTypes.SET_DEVICE,
    payload: {
      device,
    },
  };
};

export const setPage = (page) => {
  return {
    type: actionTypes.SET_PAGE,
    payload: {
      page,
    },
  };
};

export const setTemplateParameters = (parameters) => {
  return {
    type: actionTypes.SET_TEMPLATE_PARAMETERS,
    payload: {
      parameters,
    },
  };
};

export const setReportsConfigToEdit = (config: ReportConfig | null) => {
  return {
    type: actionTypes.SET_REPORT_CONFIG_TO_EDIT,
    payload: {
      config,
    },
  };
};

export const setAutoSuggestData = (collection, data) => {
  return {
    type: actionTypes.SET_AUTOSUGGEST_DATA,
    payload: {
      collection,
      data,
    },
  };
};

export const resetAutosuggestData = (collection) => {
  return {
    type: actionTypes.SET_AUTOSUGGEST_DATA,
    payload: {
      collection,
    },
  };
};

export const resetAutosuggestState = () => {
  return {
    type: actionTypes.RESET_AUTOSUGGEST_STATE,
  };
};
